/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
//manual entry
//"https://dev.d3rtlc0werw5d2.amplifyapp.com/auth/callback"
//"http://localhost:3000/"
//https://dev-sanctum.selyst.com/auth/callback

const isLocal = false;

  const awsmobile = {
    Auth: {
      region: "ap-south-1",
      Cognito: {
        userPoolId: "ap-south-1_86lUthWBi",
        userPoolClientId: "1f105dtmav274cbi3oqud9bff",
        loginWith: {
          oauth: {
            domain: "ap-south-186luthwbi.auth.ap-south-1.amazoncognito.com",
            scopes: [
              "openid",
              "email",
              "profile",
              "aws.cognito.signin.user.admin",
            ],
            redirectSignIn:
              process.env.REACT_APP_STAGE === "prod"
                ? ["https://sanctum.selyst.com/auth/callback"]
                : (isLocal ? ["http://localhost:3000/auth/callback"] : ["https://dev-sanctum.selyst.com/auth/callback"]),
            redirectSignOut:
              process.env.REACT_APP_STAGE === "prod"
                ? ["https://sanctum.selyst.com"]
                : (isLocal ? ["http://localhost:3000"] : ["https://dev-sanctum.selyst.com"]),

            responseType: "code",
          },
          username: "true",
          email: "false",
          phone: "false",
        },
      },
    },
  };
  
  export default awsmobile;
  